import React from 'react';
import { Box, Button, Card, styled } from 'bumbag';
import _get from 'lodash/get';
import type { NavigateFunction } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import medipassLogo from '@medipass/assets/images/medipass-logo.png';
import { withRouter } from '@medipass/react-core/router';
import { showNewMessage } from '@medipass/utils/intercom';
import sdk from '@medipass/web-sdk';

import Page from 'legacy/components/account/layout/Page';
import SidebarFooter from 'legacy/components/account/layout/SidebarFooter';
import WithAuthentication from 'legacy/components/WithAuthentication';

import { AUTH_URL_FORCE_LOGIN, THO_HELP_CENTRE_URL } from '../../constants';

const Wrapper = styled(Card)`
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
`;
type Props = {
  navigate: NavigateFunction;
};

class More extends React.PureComponent<Props> {
  handleLogout = async () => {
    const { navigate } = this.props;

    try {
      await sdk.auth.logout();
    } catch (err) {}

    navigate(AUTH_URL_FORCE_LOGIN);
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="More">
        <Wrapper>
          <Box textAlign="center" marginBottom="major-1" width="100%">
            <img src={medipassLogo} className="w-36" alt="medipassLogo" />
          </Box>
          <Box textAlign="center" fontWeight="semibold" marginBottom="major-1">
            {_get(sdk, 'member.firstName')} {_get(sdk, 'member.lastName')}
          </Box>
          {/* @ts-expect-error TS(2322): Type '{ children: (string | Element)[]; use: any; ... Remove this comment to see the full error message */}
          <Button use={RouterLink} to={THO_HELP_CENTRE_URL} palette="primary" variant="ghost">
            <i className={`fa fa-fw margin-right-5 fa-info-circle`} />
            Help guides
          </Button>
          {/* @ts-expect-error */}
          <Button palette="primary" variant="ghost" onClick={showNewMessage}>
            <i className={`fa fa-fw margin-right-5 fa-question-circle`} />
            Talk to us
          </Button>
          <Button palette="primary" variant="ghost" onClick={this.handleLogout}>
            <i className={`fa fa-fw margin-right-5 fa-sign-out-alt`} />
            Logout
          </Button>
        </Wrapper>
        <SidebarFooter className="margin-top-30 has-text-centered" />
      </Page>
    </WithAuthentication>
  );
}

export default withRouter(More);
